import Vue from 'vue';
export default Vue.extend({
    name: 'balanceFail',
    data: function () {
        return {
            errorMsg: '',
        };
    },
    created: function () {
        this.errorMsg = this.$route.params.errorMsg || '请您核对您的账户信息后重试';
    },
    methods: {
        backBalance: function () {
            this.$router.push({
                name: 'fundBalanceSure',
                params: { cash: this.$route.params.cash },
            });
        },
    },
});
